import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const Number: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size + 1}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.709 12.667l.453-4.075-1.657-.184-.473 4.259H8.5v1.666h4.347l-.37 3.334H8.5v1.666h3.791l-.453 4.075 1.657.184.473-4.259h3.323l-.453 4.075 1.657.184.473-4.259H23.5v-1.666h-4.347l.37-3.334H23.5v-1.666h-3.791l.453-4.075-1.657-.184-.473 4.259h-3.323zm2.767 5l.37-3.334h-3.322l-.37 3.334h3.322z"
        fill={color}
      />
    </svg>
  );
};

export default Number;
